import {
  jdDetail,
  jdDetailEdit,
  jdDetailEdit2,
  jdCategoryProps,
  jdBatchUpdateCategory,
  jdWareLocationList,
  jdVenderBrandList,
  jdUpload,
  jdDetailSupplier,
  jdFindCategoryInfo,
  isShowLengthWidthHeight,
  jdFindNontShowBrandIds,
  jdGetCategoryFeature,
  jdVenderBrandListByshopId,
  jdSellerDeliverySendPromiseTemplate,
  getSaleAttrs,
  getProductSchemas,
  listCategoryRuleTemplatesComponents,
  saveBatchTempConf,
  queryBatchDetail,
  jdBatchUpdateItemName,
  jdBatchUpdateStock,
  batchPublishItem,
} from '@/api/prod/center'
import store from '@/store'

// 过滤上传失败或为空的图片
export function _filterInvalidImg (imgsArr) {
  return imgsArr.filter(img => {
    if (!img) {
      return false
    } else if (typeof img === 'object') {
      return false
    } else {
      return true
    }
  })
} 
function _formatFeatures (features, isRequest) {
  if(isRequest) {
    let list = []
    Object.keys(features || {}).forEach(key => {
      list.push({ key, value:features[key] })
    })
    return JSON.stringify(list)
  } else {
    const object = {}
    JSON.parse(features || '[]').forEach(item => {
      object[item.key] = item.value
    })
    return object
  }
 
} 

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
  if (r.skuList && r.skuList.length > 0) {
    r.skuList = r.skuList.map(item => {
      return isRequest ? {
        ...item,
        skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : []),
        promiseConfig: JSON.stringify(item.promiseConfig ? item.promiseConfig : []),
        skuPropValues: JSON.stringify(item.skuPropValues ? item.skuPropValues : []),
        nutrientContent: JSON.stringify(item.nutrientContent ? item.nutrientContent : []),
      } : {
        ...item,
        skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : [],
        promiseConfig: item.promiseConfig ? JSON.parse(item.promiseConfig) : [],
        skuPropValues: item.skuPropValues ? JSON.parse(item.skuPropValues) : [],
        nutrientContent: item.nutrientContent ? JSON.parse(item.nutrientContent) : [],
      }
    })
  }
   // 处理长图数据，过滤掉对象格式的图片项
   const formatLengthImages = (images) => {
      if (!Array.isArray(images)) return [];
      return images.map(item => ({
        ...item,
        imageUrls: Array.isArray(item.imageUrls) 
          ? item.imageUrls.filter(url => typeof url === 'string')
          : []
      }));
    };

  return isRequest ? {
    ...r,
    itemPropValues: JSON.stringify(r.itemPropValues ? r.itemPropValues : []),
    images: JSON.stringify(r.images ? r.images : []),
    lengthImages: JSON.stringify(r.lengthImages ? formatLengthImages(r.lengthImages) : []),
    transparentImages: JSON.stringify(r.transparentImages ? r.transparentImages : []),
    specificationNames: JSON.stringify(r.specificationNames ? r.specificationNames : []),
    specifications: JSON.stringify(r.specifications ? r.specifications : []),
    specSkuImage: JSON.stringify(r.specSkuImage ? r.specSkuImage : []),
    searchImages: JSON.stringify(r.searchImages ? r.searchImages : []),
    categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
    brandId: JSON.stringify(r.brandId ? r.brandId : []),
    features: _formatFeatures(r.features, isRequest),
  } : {
    ...r,
    itemPropValues: r.itemPropValues ? JSON.parse(r.itemPropValues) : [],
    images: r.images ? JSON.parse(r.images) : [],
    // lengthImages: r.lengthImages ? JSON.parse(r.lengthImages) : [],
    lengthImages: r.lengthImages ? formatLengthImages(JSON.parse(r.lengthImages)) : [],
    transparentImages: r.transparentImages ? JSON.parse(r.transparentImages) : [],
    specificationNames: r.specificationNames ? JSON.parse(r.specificationNames) : [],
    specifications: r.specifications ? JSON.parse(r.specifications) : [],
    specSkuImage:r.specSkuImage ? JSON.parse(r.specSkuImage) : [],
    searchImages:r.searchImages ? JSON.parse(r.searchImages) : [],
    categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
    templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : [],
    brandId: r.brandId ? JSON.parse(r.brandId) : [],
    promiseConfig: r.promiseConfig ? JSON.parse(r.promiseConfig) : [],
    features: _formatFeatures(r.features),
  }
}

// 编辑详情
export function editJdDetail(data) {
  return jdDetailEdit(_formatGoodsItem(data, true)).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}
export function editJdDetail2(data,expandParams) {
  let params = _formatGoodsItem(data, true)
  params = {
    itemInfo:{...params},
    ...expandParams
  }
  return jdDetailEdit2(params).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

// 获取详情资料
export function getJdDetail(baseItemId) {
  return jdDetail({
    baseItemId
  }).then(res => {
    if (res.result === 1) {
      // debugger;
      return _formatGoodsItem(res.data)
    } else {
      return false
    }
  })
}
// 获取详情资料(供销商小店版)
export function getJdDetailSupplier(params) {
  return jdDetailSupplier(params).then(res => {
    if (res.result === 1) {
      // debugger;
      return _formatGoodsItem(res.data)
    } else {
      return false
    }
  })
}

// 查询类目属性
export function getCategoryProps(data) {
  let _shopId = store.getters.shops_getCategoryPropShopId('jd') || 82048
  let _data = {
    ...data,
    shopId: data.shopId ? data.shopId : _shopId // 默认店铺
  }
  return jdCategoryProps(_data).then(res => {
    if (res.result === 1) {
      return JSON.parse(res.data);
    } else {
      return false
    }
  })
}

export function getJdSchemas(data) {
  return getProductSchemas(data).then(res => {
    if (res.result === 1 && res?.data?.length) {
      return JSON.parse(res.data[0])
    } else {
      return {}
    }
  })
}
// 获取渲染规则（返回解析后的对象列表）
export const getJdCategoryRuleTemplatesComponents = (data) => {
  return listCategoryRuleTemplatesComponents(data).then(res => {
    if (res.result === 1) {
      return res?.data || []
    }
    return [];
  });
}
// 根据类目ID和属性类型获取销售属性
export function getJdSaleAttrs(data) {
  return getSaleAttrs(data).then(res => {
    if (res.result === 1) {
      return res.data || []
    } else {
      return []
    }
  })
}
// 批量修改类目
export function batchJdongCategory(data) {
  return jdBatchUpdateCategory(data).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

// 获取产地列表
export function getJdWareLocationList() {
  return jdWareLocationList().then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}

export function getVenderBrandList(params) {
  return jdVenderBrandList(params).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}

export function getVenderBrandListByshopId(params) {
  return jdVenderBrandListByshopId(params).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}
export function getJdSellerDeliverySendPromiseTemplate(params) {
  return jdSellerDeliverySendPromiseTemplate(params).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}

export function upload(file) {
  const fd = new FormData()
  fd.append("file", file)
  return jdUpload(fd).then(res => {
    if (res.result === 1) {
      return {url: res.data.imageUrl}
    } else {
      return false
    }
  })
}

// 查看此类目下有哪些字段有新的校验规则
// 1、是否校验首位是品牌:checkNameBrand 值:1 是 0或者null 否 2、POP商品名称字符限制：popNameLength
export function getJdNeedValidateField(data) {
  let _shopId = store.getters.shops_getCategoryPropShopId('jd') || 82048
  let _data = {
    ...data,
    shopId: data.shopId ? data.shopId : _shopId // 默认店铺
  }
  return jdFindCategoryInfo(_data).then(res => {
    if (res.result === 1) {
      return (res.data?.category?.features || []).filter(item => {
        return ['checkNameBrand', 'popNameLength'].includes(item.featureKey) && !!Number(item.featureValue);
      }).reduce((fieldMap, curr) => {
        if(curr.featureKey === 'popNameLength'){
          fieldMap[curr.featureKey] = parseInt(curr.featureValue) || 60
        }else{
          fieldMap[curr.featureKey] = true
        }
        return fieldMap;
      }, {})
    } else {
      return false
    }
  })
}
// 是否展示长宽高
export function getIsShowLengthWidthHeight(data) {
  return isShowLengthWidthHeight(data).then(res => {
    return res.data
  })
}



// 查看京东平台哪些品牌不需要回显到标题部分
export function getJdNoShowBrandId() {
  return jdFindNontShowBrandIds().then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}

/**
 * 获取类目的推荐图规则
 * @param {* } 
 * categoryId 
 * shopId
 * @returns 
 */
export const getCategoryFeature = (params) => {
  return jdGetCategoryFeature(params).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}
// 针对批量铺货设置保存
export const saveBatchTempConfJd = (data) => {
  return saveBatchTempConf({data,platform:'jd'}).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}
// 获取批量铺货商品详情信息
export const queryBatchDetailJd = (data) => {
  return queryBatchDetail({data,platform:'jd'}).then(res => {
    if(res.result === 1) {
      res.data.items = res.data.items.map(item => {
        item.shopBrandConf = JSON.parse(item.shopBrandConf || '[]')
        return item
      })
      return res.data
    }
    return false
  })
}
export const batchUpdateName = (data) => {
  return jdBatchUpdateItemName({data}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
export const batchUpdateStock = (data) => {
  return jdBatchUpdateStock({data}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
export const batchPublishItemJd = (data) => {
  return batchPublishItem({data,platform:'jd'}).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}

